
import { mapState } from "pinia";
import { defineComponent } from "vue";
import {
  IAccumulation,
  IAccumulationType,
  useAccumulations,
  useOrgSettings,
} from "@/services";
import { get } from "lodash-es";
import { formatValue, getCurrencySign } from "@/util/helpers";
import GridBox from "@/components/shared/GridBox.vue";
import Spinner from "@/components/shared/Spinner.vue";

interface IBufferedAccumulationType extends IAccumulationType {
  bufferIndex: number;
  typeIndex: number;
}
export default defineComponent({
  name: "LocationAccumulations",
  components: {
    GridBox,
    Spinner,
  },
  props: {
    accumulations: {
      type: Array as () => IAccumulation[],
      default: () => [],
    },
  },
  data: () => ({
    currentTypeIndex: 0,
    currentBufferIndex: 0,
    lI: 0,
    rI: 3,
  }),
  computed: {
    ...mapState(useOrgSettings, ["currencySymbol"]),
    isLoadingAccumulations(): boolean {
      return useAccumulations().isLoadingAccumulations;
    },
    allTypes(): string[] {
      return [
        ...new Set(
          this.accumulations
            .map((a) => a.accumulationTypes.map((type) => type.type))
            .flat()
        ),
      ];
    },
    currentBuffers(): number[] {
      return this.accumulations
        .filter((acc) =>
          acc.accumulationTypes.some(
            (type) => type.type === this.allTypes[this.currentTypeIndex]
          )
        )
        .map((acc) => acc.buffer);
    },
    bufferedAccumulationTypes(): IBufferedAccumulationType[] {
      return this.accumulations
        .map((a, bufferIndex) =>
          a.accumulationTypes.map((t, typeIndex) => ({
            ...t,
            bufferIndex,
            typeIndex,
          }))
        )
        .flat();
    },
  },
  watch: {
    currentTypeIndex: {
      handler(index: number) {
        this.$nextTick(() => {
          this.animateTab(index);
        });
      },
      immediate: true,
    },
    isLoadingAccumulations: {
      handler(val: boolean) {
        if (!val) {
          this.$nextTick(() => {
            this.animateTab(this.currentTypeIndex);
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatValue,
    getCurrencySign,
    animateTab(index: number) {
      const tabEl = get(this, ["$refs", "aTypes", index]);
      if (tabEl) {
        this.rI = tabEl.offsetWidth + tabEl.offsetLeft;
        this.lI = tabEl.offsetLeft;
      }
    },
    getBatItems(bat: IBufferedAccumulationType) {
      return bat.accumulations.concat([
        {
          businessLine: "Total",
          value: bat.totalValue,
          count: bat.totalCount,
        },
      ]);
    },
    getBatStyle(bat: IBufferedAccumulationType) {
      return {
        transform: `translateX(${
          bat.bufferIndex < this.currentBufferIndex ||
          bat.typeIndex < this.currentTypeIndex
            ? "-100%"
            : bat.bufferIndex > this.currentBufferIndex ||
              bat.typeIndex > this.currentTypeIndex
            ? "100%"
            : "0"
        })`,
      };
    },
  },
});
